// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w1-z","displaySixCardTiles":"x1-z"};